module.exports = __webpack_public_path__ + "img/HY3703-153.ccb642b6.jpg";